module.exports = __webpack_public_path__ + "img/policy-scope-button.c927ddea.png";